import { gql } from '@apollo/client'

export const GET_LIST_WORDSPACE_JOB_PAGINATED = gql`
  query getListWorkspaceJobPaginated(
    $pagination: PaginatedWorkspaceJobInput!
    $automaticallyGenerated: Boolean
    $status: DashboardStatus
    $term: String
    $type: DashboardType
    $sort: JobsSortInput
    $withoutFolder: Boolean
    $folderId: String
  ) {
    listWorkspaceJobPaginated(
      pagination: $pagination
      query: {
        automaticallyGenerated: $automaticallyGenerated
        status: $status
        term: $term
        type: $type
        sort: $sort
        withoutFolder: $withoutFolder
        folderId: $folderId
      }
    ) {
      data {
        id
        workspaceId
        name
        type
        description
        ownerName
        isOwner
        createdAt
        updatedAt
        thumbnails
        isAutomaticallyGenerated
        publicationStatus
        details {
          brand
          territory
          startDate
          endDate
          gender
          age
          country
        }
        report {
          id
        }
      }
      totalCount
      cursor
    }
  }
`

export const GET_RECENTS_DASHBOARDS = gql`
  query getRecentsDashboards($pagination: PaginatedWorkspaceJobInput!, $sort: JobsSortInput) {
    listWorkspaceJobPaginated(pagination: $pagination, query: { sort: $sort }) {
      data {
        id
        name
        updatedAt
      }
    }
  }
`

export const GET_DASHBOARDS_COUNT = gql`
  query getWorkspaceJobsCount {
    listWorkspaceJobPaginated {
      totalCount
    }
  }
`

export const GET_JOBS_WITH_FOLDERS = gql`
  query getWorkspaceJobsWithFoldersPaginated(
    $workspaceId: String!
    $pagination: PaginatedWorkspaceJobInput!
    $term: String
  ) {
    me {
      ... on User {
        id
        userActivity {
          mostRecentJob(workspaceId: $workspaceId) {
            createdAt
            description
            id
            isOwner
            isPublic
            name
            ownerName
            type
            updatedAt
            workspaceId
            isAutomaticallyGenerated

            pins {
              creatorAmount
              postAmount
              territoriesAmount
              totalPins
            }
          }
        }
      }
    }
    listWorkspaceJobPaginated(pagination: $pagination, query: { term: $term }) {
      totalCount
      cursor
      data {
        createdAt
        description
        id
        isOwner
        isPublic
        name
        ownerName
        type
        updatedAt
        workspaceId
        isAutomaticallyGenerated

        pins {
          creatorAmount
          postAmount
          territoriesAmount
          totalPins
        }
      }
    }
  }
`

export const GET_JOB_FOLDERS = gql`
  query getJobFolders($jobId: String!, $pagination: PaginationInputs!) {
    getWorkspaceJob(id: $jobId) {
      id
      foldersPaginated(pagination: $pagination) {
        totalCount
        data {
          createdAt
          id
          name
          pins {
            creatorAmount
            postAmount
            territoriesAmount
            totalPins
          }
        }
      }
    }
  }
`

export const GET_TERRITORY_COMPARE_DATA_UNIVERSE = gql`
  query GET_TERRITORY_COMPARE_DATA_UNIVERSE(
    $componentId: String!
    $dashboardId: String
    $providers: [Providers!]
    $publishedAt: RangeQuery
    $timeRangeObject: TimeRange
    $genders: [String!]
    $ages: [String!]
    $countries: [String!]
    $creatorCountries: [Country!]
  ) {
    getJobDashboardComponentById(componentId: $componentId, dashboardId: $dashboardId) {
      ... on GetJobDashboardComponentResponse {
        jobDashboardComponent {
          id

          ... on BrandCompareComponent {
            componentBody {
              entityId
            }
            data {
              name
              territoryId

              territoryPerformance {
                totalPosts(
                  timeRange: $timeRangeObject
                  providers: $providers
                  publishedAt: $publishedAt
                  territoryContentFilters: { creatorCountries: $creatorCountries }
                )
                metrics(
                  timeRange: $timeRangeObject
                  providers: $providers
                  publishedAt: $publishedAt
                  ages: $ages
                  countries: $countries
                  genders: $genders
                ) {
                  totalViews
                  totalEngagement
                }
              }
            }
          }

          ... on TerritoryCompareComponent {
            componentBody {
              entityId
            }
            data {
              name
              territoryId

              territoryPerformance {
                totalPosts(
                  timeRange: $timeRangeObject
                  providers: $providers
                  publishedAt: $publishedAt
                  territoryContentFilters: { creatorCountries: $creatorCountries }
                )
                metrics(
                  timeRange: $timeRangeObject
                  providers: $providers
                  publishedAt: $publishedAt
                  ages: $ages
                  countries: $countries
                  genders: $genders
                ) {
                  totalViews
                  totalEngagement
                }
              }
            }
          }
        }
      }
    }
  }
`

export const CREATE_TERRITORY_ANALYSIS = gql`
  mutation CREATE_TERRITORY_ANALYSIS($workspaceJobTerritoryAnalysis: CreateWorkspaceJobTerritoryAnalysisInput!) {
    createWorkspaceJobTerritoryAnalysis(workspaceJobTerritoryAnalysis: $workspaceJobTerritoryAnalysis) {
      ... on WorkspaceJob {
        id
        workspaceId
        name
      }

      ... on StatusMessage {
        success
        title
        message
      }
    }
  }
`

export const CREATE_WORKSPACE_JOB_DEMAND_SPACES = gql`
  mutation CREATE_WORKSPACE_JOB_DEMAND_SPACES($workspaceJobDemandSpaces: CreateWorkspaceJobDemandSpacesInput!) {
    createWorkspaceJobDemandSpaces(workspaceJobDemandSpaces: $workspaceJobDemandSpaces) {
      ... on WorkspaceJob {
        id
        workspaceId
        name
      }

      ... on StatusMessage {
        success
        title
        message
      }
    }
  }
`

export const GET_JOB_EXTERNAL_FOLDERS = gql`
  query GET_JOB_EXTERNAL_FOLDERS($pagination: PaginationInputs, $name: String) {
    listWorkspaceJobExternalFolders(pagination: $pagination, name: $name) {
      data {
        id
        name
        jobsCount
      }
      totalCount
      cursor
    }
  }
`

export const CREATE_JOB_EXTERNAL_FOLDER = gql`
  mutation createWorkspaceJobExternalFolder($input: CreateWorkspaceJobExternalFolderInput!) {
    createWorkspaceJobExternalFolder(input: $input) {
      ... on WorkspaceJobExternalFolderModel {
        name
        id
      }
      ... on StatusMessage {
        success
      }
    }
  }
`

export const DELETE_JOB_EXTERNAL_FOLDER = gql`
  mutation deleteWorkspaceJobExternalFolder($input: DeleteWorkspaceJobExternalFolderInput!) {
    deleteWorkspaceJobExternalFolder(input: $input) {
      success
      code
      message
    }
  }
`

export const EDIT_JOB_EXTERNAL_FOLDER = gql`
  mutation editWorkspaceJobExternalFolder($input: EditWorkspaceJobExternalFolderInput!) {
    editWorkspaceJobExternalFolder(input: $input) {
      id
      name
    }
  }
`

export const GET_JOB_EXTERNAL_FOLDER = gql`
  query getWorkspaceJobExternalFolder($folderId: String!) {
    getWorkspaceJobExternalFolder(folderId: $folderId) {
      id
      name
      jobsCount
    }
  }
`

export const ADD_DASHBOARD_TO_FOLDER = gql`
  mutation createWorkspaceJobFolderRelations($input: CreateWorkspaceJobFolderRelationsInput!) {
    createWorkspaceJobFolderRelations(input: $input) {
      success
      code
      message
    }
  }
`

export const CREATE_JOB_CSV_EXPORT = gql`
  mutation CreateExportCsv($input: ExportCsvInput!) {
    createExportCsv(input: $input) {
      success
      code
      message
    }
  }
`

export const DUPLICATE_WORKSPACE_DASHBOARD = gql`
  mutation duplicateWorkspaceDashboard($duplicateWorkspaceJobInput: DuplicateWorkspaceJobInput!) {
    duplicateWorkspaceJob(duplicateWorkspaceJobInput: $duplicateWorkspaceJobInput) {
      success
      code
      title
      message
    }
  }
`

export const GET_DASHBOARD_TERRITORIES = gql`
  query GET_DASHBOARD_TERRITORIES(
    $jobId: String!
    $folders: [String!]
    $dateRange: Int = 12
    $limit: Int! = 25
    $offset: Int! = 0
    $query: SearchTerritoryInput
  ) {
    getWorkspaceJob(id: $jobId) {
      description
      id
      name
      type

      pins {
        paginatedTerritories(folders: $folders, limit: $limit, offset: $offset, query: $query) {
          rows
          pinnedTerritories {
            id
            territory {
              name
              territoryId
              ... on SavedPostSearch {
                filters
                savedPostSearchId: id
              }
              ... on Subtopic {
                subtopicId: id
                deprecatedSince
                isTrending
              }
              ... on Topic {
                topicId: id
                deprecatedSince
              }
              ... on Niche {
                nicheId: id
                parent {
                  territoryId
                  name
                }
              }
              territoryPerformance {
                relevancev2(
                  filters: {
                    timeRange: { timeUnit: month, timeValue: $dateRange }
                    interval: { timeUnit: month, type: calendar }
                  }
                ) {
                  total
                  startDate
                  sparkline
                  interval
                  endDate
                }

                totalPosts(timeRange: { timeUnit: month, timeValue: $dateRange })

                sampledMetrics(filters: { timeRange: { timeUnit: month, timeValue: 12 } }) {
                  avgEngagement
                  avgViews
                }
              }
            }
          }
        }
      }
    }
  }
`
